import { create } from 'zustand';

import { FontData, EditHistoryStore } from '../../types/text';

import { storeInitializer } from './common';

export const useFontDataHistory = create<EditHistoryStore<FontData>>()(
  storeInitializer({ prev: [['', []]] }),
);
